// ── OSS base shorthand ──
const OSS = "https://skyagent-artifacts.skywork.ai/router/agent/2026-05-18/prod_agent_a846de8d-e74f-4935-a1af-f907b9b64fb4";

export const COURSES = [
  {
    id: "ryt200",
    code: "RYT200",
    title: "RYT200 瑜伽師資培訓課程",
    titleEn: "Yoga Teacher Training",
    cert: "Yoga Alliance 國際認可",
    badge: "旗艦課程",
    badgeColor: "gold",
    highlight: true,
    description: "香港最具口碑的200小時師資培訓，由 E-RYT 500 導師 Virginia Law 親自主理，HKU SPACE 主辦。逾37屆、300+位畢業生見證。",
    details: ["200 小時系統課程", "體式學 · 解剖學 · 哲學", "教學方法論 · 試教評核", "Thinkific 學員專區支援"],
    nextDate: "2026/27學年課程已於5月23日正式開課（進行中）",
    host: "HKU SPACE 主辦",
    link: "https://abhyaas.thinkific.com",
    image: `${OSS}/1_6179eb8ceb6b481ea81a019758f519cd.png`,
  },
  {
    id: "ryt300",
    code: "RYT300",
    title: "RYT300 進階瑜伽師資培訓課程",
    titleEn: "Advanced Yoga Teacher Training",
    cert: "Yoga Alliance 國際認可",
    badge: "進階",
    badgeColor: "brown",
    highlight: false,
    description: "為已持 RYT200 資格的導師而設，深化教學技巧、哲學實踐與個人修行，邁向 RYT500 認證。",
    details: ["300 小時深化課程", "進階體式與序列設計", "哲學深化 · 個人修行", "助理教學實習"],
    nextDate: "開班日期待定",
    link: "#contact",
    image: `${OSS}/Dimpasana%20-%20Yogaroot_8726_1b0f2f70041d4c6db27dc382eac588fa.jpg`,
  },
  {
    id: "yin",
    code: "YACEP",
    title: "YACEP 正念陰瑜伽導師培訓課程",
    titleEn: "Mindfulness Yin Yoga Teacher Training",
    cert: "Yoga Alliance YACEP 認可",
    badge: "YACEP",
    badgeColor: "green",
    highlight: false,
    description: "結合正念靜觀與陰瑜伽的深度師資培訓，學習透過筋膜釋放與呼吸調節，支援學員身心療癒。",
    details: ["正念靜觀理論", "陰瑜伽體式深度分析", "筋膜解剖學", "療癒序列設計"],
    nextDate: "開班日期待定",
    link: "#contact",
    image: `${OSS}/E43A9E70-CE4C-45E7-B4FC-9F19442CC7A4_6e8cb42687024661b5670e13f5d39b45.jpg`,
  },
  {
    id: "elderly",
    code: "YACEP",
    title: "YACEP 樂齡瑜伽導師培訓課程",
    titleEn: "Elderly Yoga Teacher Training",
    cert: "Yoga Alliance YACEP 認可",
    badge: "YACEP",
    badgeColor: "green",
    highlight: false,
    description: "專為教授長者瑜伽而設計，涵蓋長者身心需求、安全指引、適應性體式及情緒支援技巧。",
    details: ["長者生理心理需求", "安全調整與輔具使用", "慢性病與體式禁忌", "樂齡序列設計"],
    nextDate: "開班日期待定",
    link: "#contact",
    image: `${OSS}/0B9A8726_e3ad776b1d2d4007a12196a7830e2077.jpg`,
  },
  {
    id: "chair",
    code: "YACEP",
    title: "YACEP 椅子瑜伽導師培訓課程",
    titleEn: "Chair Yoga Teacher Training",
    cert: "Yoga Alliance YACEP 認可",
    badge: "YACEP",
    badgeColor: "green",
    highlight: false,
    description: "學習如何利用椅子為輔具，讓行動不便、長者或辦公室人士也能安全練習瑜伽。",
    details: ["椅子輔具使用技巧", "適應性體式設計", "辦公室 / 社區應用", "安全守則"],
    nextDate: "開班日期待定",
    link: "#contact",
    image: `${OSS}/2025_05_15_0953_806a018dfb9e4034aa71cba02dcc2538.jpg`,
  },
  {
    id: "wheel",
    code: "YACEP",
    title: "YACEP 瑜伽輪導師培訓課程",
    titleEn: "Yoga Wheel Teacher Training",
    cert: "Yoga Alliance YACEP 認可",
    badge: "YACEP",
    badgeColor: "green",
    highlight: false,
    description: "掌握瑜伽輪的專業應用，學習如何引導學員安全使用瑜伽輪深化後彎、開胸及平衡體式。",
    details: ["瑜伽輪解剖學基礎", "安全使用與禁忌", "後彎與開胸序列", "進階挑戰體式"],
    nextDate: "開班日期待定",
    link: "#contact",
    image: `${OSS}/2021_12_090510_beeaa0483033465bbdda5a3dda71b762.jpg`,
  },
  {
    id: "prenatal",
    code: "RPYT",
    title: "RPYT 產前瑜伽導師培訓課程",
    titleEn: "Prenatal Yoga Teacher Training",
    cert: "Yoga Alliance RPYT 認可",
    badge: "RPYT",
    badgeColor: "rose",
    highlight: false,
    description: "由 RPYT 認證導師 Virginia Law 主理，學習安全陪伴孕婦練習瑜伽，支援孕期身心健康與分娩準備。",
    details: ["孕期生理心理變化", "各孕期安全體式", "呼吸與生產準備", "產後恢復指引"],
    nextDate: "開班日期待定",
    link: "#contact",
    image: `${OSS}/Yoga%20Roots%20HK4429_50ea260048ae4a819d3d769e59e962c4.jpg`,
  },
  {
    id: "yoga-sutra",
    code: "YACEP",
    title: "YACEP 瑜伽經師資培訓課程",
    titleEn: "Patanjali Yoga Sutra Teacher Training",
    cert: "Yoga Alliance YACEP 認可",
    badge: "YACEP",
    badgeColor: "green",
    highlight: false,
    description: "以廣東話細讀《瑜伽經》行門篇（Sadhana Pada），深入探討心念的控制與止息，課程時數亦計入 RYT300 進階培訓。",
    details: ["《瑜伽經》原文細讀", "行門篇哲學深化", "心念管理與修行", "RYT300 認可時數"],
    nextDate: "請查閱海報或聯絡查詢",
    link: "#contact",
    image: `${OSS}/YACEP%20Yoga%20Sutra_fa32f639282c4318a6779fd5fdcce7a3.png`,
  },
  {
    id: "adjustment",
    code: "YACEP",
    title: "YACEP 體式調整藝術課程",
    titleEn: "Art of Adjustment Teacher Training",
    cert: "Yoga Alliance YACEP 認可",
    badge: "YACEP",
    badgeColor: "green",
    highlight: false,
    description: "專為瑜伽導師而設的調整技巧深化課程，學習安全、有效、有覺察的輔助調整，提升教學精準度與學員體驗。",
    details: ["安全調整原則", "常見體式調整技巧", "知情同意與邊界設立", "實習練習與評核"],
    nextDate: "開班日期待定（Date TBC）",
    link: "#contact",
    image: `${OSS}/DSC06757_97afb4fd52b84e308167177a8aae87b0.jpg`,
  },
];

// Cohort slideshow photos
export const COHORT_PHOTOS = [
  { src: `${OSS}/DSC06757_97afb4fd52b84e308167177a8aae87b0.jpg`, label: "RYT200 課室實況" },
  { src: `${OSS}/E43A9E70-CE4C-45E7-B4FC-9F19442CC7A4_6e8cb42687024661b5670e13f5d39b45.jpg`, label: "靜觀冥想課" },
  { src: `${OSS}/IRIS%20Yoga%20hxeartwork%2020190428%20a%20092_1e11e3c288a14010aab2721054d07309.jpg`, label: "戶外瑜伽活動" },
  { src: `${OSS}/0B9A8726_e3ad776b1d2d4007a12196a7830e2077.jpg`, label: "樂齡瑜伽培訓" },
  { src: `${OSS}/Yogaroot_8436_1261674c975c44b783348a8989724672.jpg`, label: "體式示範" },
];

// Yoga Alliance certification badges
export const CERT_BADGES = [
  { src: `${OSS}/RYS200%20%282%29_8e28880db6c44438b8235e4a203c9cae.png`, label: "RYS 200" },
  { src: `${OSS}/RYS300%20%282%29_8d7204a65e5d4a6e865ba315c4f1afd1.png`, label: "RYS 300" },
  { src: `${OSS}/RPYS%20%282%29_b680a33726af4b4588f89f9f4def75b1.png`, label: "RPYS" },
  { src: `${OSS}/YACEP%20%281%29_26ee155c55df45c5827f091c99919484.png`, label: "YACEP" },
];

// Knowledge library articles (IG graphics as entry points)
export const KNOWLEDGE_ARTICLES = [
  {
    id: "inhale-new-beginning",
    title: "每一次吸氣，都是新的開始",
    titleEn: "Every Inhale Is a New Beginning",
    category: "呼吸與正念",
    summary: "呼吸是我們與生俱來最強大的工具。每一次吸氣，帶來的不只是氧氣，更是重新選擇的機會。",
    image: `${OSS}/Every%20inhale%20is%20a%20new%20beginning.%20Traditional%20Chinese%20%E6%AF%8F%E4%B8%80%E6%AC%A1%E5%90%B8%E6%B0%A3%EF%BC%8C%E9%83%BD%E6%98%AF%E6%96%B0%E7%9A%84%E9%96%8B%E5%A7%8B%E3%80%82_b6f77599d3b44e4b8afe0d8a4a22e030.png`,
    tags: ["呼吸法", "正念", "情緒管理"],
  },
  {
    id: "stillness-peace",
    title: "在靜默中找到自己的平靜",
    titleEn: "Embrace the Stillness Within",
    category: "靜觀冥想",
    summary: "在每一次呼吸、每一個當下，都隱藏著平靜的入口。瑜伽教我們停下來，聆聽內在的聲音。",
    image: `${OSS}/Instagram%20Post%20-%20Embrace%20the%20stillness%20within%3B%20find%20your%20peace%20in%20every%20breath%20and%20every%20moment.%20%281%29_b976238ec5f2425faf74803872eecdc4.png`,
    tags: ["靜觀", "冥想", "內在平靜"],
  },
  {
    id: "yoga-emotional-first-aid",
    title: "瑜伽與情緒急救：身體是情緒的地圖",
    titleEn: "Yoga as Emotional First Aid",
    category: "情緒管理",
    summary: "情緒不是問題，它是信息。瑜伽給我們一個安全的空間，讓身體帶領心靈找到出路。",
    image: `${OSS}/1_6179eb8ceb6b481ea81a019758f519cd.png`,
    tags: ["情緒急救", "身心連結", "療癒"],
  },
  {
    id: "patanjali-yoga-sutra",
    title: "《瑜伽經》冷知識：心念究竟是什麼？",
    titleEn: "Yoga Sutra: What Is the Mind?",
    category: "瑜伽哲學",
    summary: "Patanjali 說「Yogas chitta vritti nirodhah」——瑜伽是心念波動的止息。但「心念」到底是什麼？我們能真的控制它嗎？",
    image: `${OSS}/YACEP%20Yoga%20Sutra_fa32f639282c4318a6779fd5fdcce7a3.png`,
    tags: ["瑜伽經", "哲學", "心念"],
  },
  {
    id: "fascia-yin-yoga",
    title: "筋膜冷知識：為什麼陰瑜伽能改變身體？",
    titleEn: "Fascia & Yin Yoga: The Science",
    category: "解剖學",
    summary: "筋膜佔人體結締組織的大部分，卻長期被忽視。陰瑜伽如何透過長時間保持體式，重塑筋膜的彈性與流動？",
    image: `${OSS}/E43A9E70-CE4C-45E7-B4FC-9F19442CC7A4_6e8cb42687024661b5670e13f5d39b45.jpg`,
    tags: ["筋膜", "陰瑜伽", "解剖學"],
  },
  {
    id: "elderly-yoga-benefits",
    title: "長者練瑜伽的5大好處（科學實證）",
    titleEn: "5 Evidence-Based Benefits of Yoga for Seniors",
    category: "樂齡健康",
    summary: "研究顯示，規律練習瑜伽能顯著降低長者跌倒風險、改善睡眠質素，並減少孤獨感。數據說話，瑜伽不只是拉筋。",
    image: `${OSS}/0B9A8726_e3ad776b1d2d4007a12196a7830e2077.jpg`,
    tags: ["長者瑜伽", "健康", "研究"],
  },
];

export const CREDENTIALS = [
  { label: "E-RYT 500", desc: "Yoga Alliance 最高級別認證導師" },
  { label: "RPYT", desc: "Yoga Alliance 產前瑜伽認證" },
  { label: "YACEP", desc: "Yoga Alliance 持續教育提供者" },
  { label: "HKU SPACE", desc: "香港大學 RYT200 課程首席導師 (Lead Trainer)" },
  { label: "37 屆", desc: "RYT200 師資培訓完成屆數" },
  { label: "300+", desc: "已認證畢業生人數" },
];

export const NAV_LINKS = [
  { label: "首頁", href: "/" },
  { label: "關於 Virginia", href: "/about" },
  { label: "課程", href: "/courses" },
  { label: "瑜伽知識庫", href: "/knowledge" },
  { label: "聯絡", href: "#contact" },
];
